import { Navigate, useLocation, useParams } from "react-router-dom";
import {
  getInicioCotizacion,
  getPasoDatos,
  getPasoVehiculo,
} from "../../utils/getRubro";
import { CampoCotizacion } from "../Slides/Comunes/Cotizacion/validaciones";

interface RedirectPasoCotizacionProps {
  rubro: "auto" | "moto";
  destino: "inicio" | "vehiculo" | "datos";
  /**
   * Campo del paso unificado al que corresponde el `?error=` que traía esta
   * ruta. La página de precios vuelve al cotizador con el error apuntando a la
   * pantalla que lo causó (`/email?error=...`); como esa pantalla ya no existe,
   * se traduce a un campo para poder marcarlo.
   */
  campo?: CampoCotizacion;
}

const destinos = {
  inicio: getInicioCotizacion,
  vehiculo: getPasoVehiculo,
  datos: getPasoDatos,
};

/**
 * Manda una ruta del cotizador de una pregunta por pantalla al paso que ahora
 * la contiene. Esas URLs siguen vivas en historial, bookmarks, campañas y en
 * los redirects de error de la página de precios: sin esto quedan en blanco.
 */
export const RedirectPasoCotizacion = ({
  rubro,
  destino,
  campo,
}: RedirectPasoCotizacionProps) => {
  const { compania } = useParams();
  const { search } = useLocation();

  const params = new URLSearchParams(search);
  if (campo && params.get("error")) params.set("campo", campo);
  const query = params.toString();

  return (
    <Navigate
      to={destinos[destino](rubro, compania) + (query ? `?${query}` : "")}
      replace
    />
  );
};
